var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("sys-register-base", {
    attrs: {
      model: _vm.modelBase,
      title: "Assinar Espelho de Ponto",
      icon: "mdi-signature-freehand",
      color: "purple white--text",
      show: _vm.dialog,
      maxWidth: "700",
      actions: false,
    },
    on: {
      "update:model": function ($event) {
        _vm.modelBase = $event
      },
      "update:show": function ($event) {
        _vm.dialog = $event
      },
    },
    scopedSlots: _vm._u([
      {
        key: "form",
        fn: function () {
          return [
            _vm.error
              ? _c(
                  "v-alert",
                  {
                    staticClass: "mb-4",
                    attrs: { type: "error", dense: "", outlined: "" },
                  },
                  [_vm._v(" " + _vm._s(_vm.message) + " ")]
                )
              : _vm._e(),
            !_vm.error && _vm.infoMessage
              ? _c(
                  "v-alert",
                  {
                    staticClass: "mb-4",
                    attrs: { type: "info", dense: "", outlined: "" },
                  },
                  [_vm._v(" " + _vm._s(_vm.infoMessage) + " ")]
                )
              : _vm._e(),
            _vm.loading
              ? _c(
                  "div",
                  { staticClass: "text-center py-12" },
                  [
                    _c("v-progress-circular", {
                      attrs: { indeterminate: "", color: "purple", size: "48" },
                    }),
                    _c("p", { staticClass: "mt-4" }, [
                      _vm._v("Preparando documento para assinatura..."),
                    ]),
                  ],
                  1
                )
              : _vm.embedUrl
              ? _c("iframe", {
                  staticClass: "sign-embedded-frame",
                  attrs: {
                    src: _vm.embedUrl,
                    title: "Assinatura do Espelho de Ponto",
                    allow: "geolocation; camera; microphone",
                  },
                })
              : _vm._e(),
            _vm.embedUrl
              ? _c(
                  "v-row",
                  { staticClass: "mt-2", attrs: { "no-gutters": "" } },
                  [
                    _c(
                      "v-col",
                      { staticClass: "text-right", attrs: { cols: "12" } },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { text: "", color: "grey darken-1" },
                            on: {
                              click: function ($event) {
                                _vm.dialog = false
                              },
                            },
                          },
                          [_vm._v(" Fechar ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }